import type { DomPurifyConfig } from "./types";

export default {
  ALLOWED_TAGS: [
    "p",
    "em",
    "u",
    "strong",
    "h1",
    "h2",
    "h3",
    "ul",
    "ol",
    "li",
    "table",
    "thead",
    "tr",
    "th",
    "tbody",
    "tr",
    "td",
    "blockquote",
    "a",
    "br",
  ],
  KEEP_CONTENT: true,
  ALLOWED_ATTR: [
    "title",
    "href",
    "target",
    "style",
    "class",
    "rel",
    "colspan",
    "rowspan",
  ],
  RETURN_DOM: false,
} satisfies DomPurifyConfig;
